import { Fragment, type PropsWithChildren, type ReactNode } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";

interface Props {
  children: ReactNode;
}

export const EllipsisMenu = ({ children }: Props) => (
  <Menu as="div" className="w-8 h-8">
    {({ open }) => (
      <>
        <MenuButton
          as="button"
          className={clsx(
            "button secondary-button bg-v2-primary sm font-bold w-8 h-8 p-0 border-v2-secondary hover:border-v2-action hover:bg-v2-secondary",
            {
              "bg-v2-secondary border-v2-action": open,
            },
          )}
        >
          <i
            className={clsx("fa-regular fa-sharp fa-ellipsis", {
              "text-white": open,
            })}
          />
        </MenuButton>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <MenuItems
            anchor="bottom end"
            className="z-10 bg-white rounded-lg elevation-1 text-sm py-1 pb-1"
          >
            {children}
          </MenuItems>
        </Transition>
      </>
    )}
  </Menu>
);

EllipsisMenu.Item = ({
  children,
  className,
  ...props
}: PropsWithChildren<any>) => (
  <MenuItem {...props} className="block no-underline w-full">
    {({ focus }) => {
      return (
        <div
          className={twMerge(
            clsx(
              "px-4 text-interstellar+2 h-8",
              "flex items-center cursor-pointer whitespace-nowrap",
              {
                "bg-cosmic-4": focus,
              },
            ),
            className,
          )}
        >
          {children}
        </div>
      );
    }}
  </MenuItem>
);
